<div class="container pb-4 px-0" *ngIf="!this.processing else this.loadingModalTemplate">
  <div class="col-12 pb-0 pt-0 " *ngIf="this.clientInfo?.coach.id">
    <div class="dakkini-card height-100 justify-content-center text-center">
      <img style="margin: 1em auto" width="100" src="assets/images/espiral.svg" />
      <h3 class="text-center text-uppercase  padding fs-26px" i18n>Agenda una llamada</h3>
      <p class="text-center padding" i18n>Hemos asignado a <strong>{{this.clientInfo?.coach.name}}
          {{this.clientInfo?.coach.lastname}}</strong> como tu
        coach.<br>Accede ahora a su calendario y agenda tu llamada inicial.</p>
      <a style="background-color:var(--BhavDarkGreen); margin:1rem auto;" class="btn btn-schedule"
        [routerLink]="['/platform/schedule', this.clientInfo?.coach.id, 'appointments','.']"
        [href]="this.clientInfo.coach.calendly_url" i18n>Agendar
        llamada</a>
      <br />
      <p i18n>Esta llamada inicial tiene una duración aproximada de <strong>20-30 min</strong>. El propósito de
        esta llamada
        es revisar tu cuestionario para diseñar tu protocolo personalizado y darte la información que necesitas.
      </p>
      <p class="strong" i18n>Esta llamada no es una consulta o terapia.</p>
      <br />
      <p i18n>Si quieres complementar tu proceso con apoyo terapéutico, pregunta a tu coach sobre las alternativas
        que podemos ofrecerte.</p>
      <br />
      <p class="text-center center-padding mt-2" style="color: rgba(165, 163, 161, 1); font-size:12px; " i18n>Revisa <a
          [routerLink]="['/platform/appointments/.']">aquí</a> tus sesiones agendadas.</p>
    </div>
  </div>
</div>

<ng-template #loadingModalTemplate>
  <loading-dots-modal-component></loading-dots-modal-component>
</ng-template>